
import { FavoriteActiveIcon } from '@/components/icons/favorite-active-icon';
import { FavoriteIcon } from '@/components/icons/favorite-icon';
import { useProfile } from '@/hooks/profile/profile';
import clsx from 'clsx';
import favoriteTheaterIconStyles from './favorite-theater-icon.module.scss';

type FavoriteTheaterIconComponentProps = {
  className?: string;
  isActive: boolean;
  onClick?: () => void;
};

export const FavoriteTheaterIconComponent = ({
  className,
  isActive,
  onClick,
}: FavoriteTheaterIconComponentProps): React.JSX.Element | null => {
  const { data: profile } = useProfile();

  const displayAction = (): React.JSX.Element | null => {
    if (!profile) return null;

    return getIcon();
  };

  const getIcon = (): React.JSX.Element => {
    if (isActive) {
      return (
        <FavoriteActiveIcon className={clsx(
          'text-primary icon cursor-pointer',
          favoriteTheaterIconStyles['favorite-theater-icon'],
          className
        )}
        role="img"
        onClick={() => profile && onClick?.()}
        >
          <title id="icon-title-unfavorite">Unfavorite this Theatre</title>
        </FavoriteActiveIcon>
      );
    }

    return (
      <FavoriteIcon className={clsx(
        'icon cursor-pointer',
        favoriteTheaterIconStyles['favorite-theater-icon'],
        className
      )}
      role="img"
      onClick={() => profile && onClick?.()}
      >
        <title id="icon-title-favorite">Favorite this Theatre</title>
      </FavoriteIcon>
    );
  };

  return displayAction();
};
